const spacing = {
  base_unit_none: '0px',
  base_unit_1: '2px',
  base_unit_2: '4px',
  base_unit_3: '8px',
  base_unit_4: '12px',
  base_unit_5: '16px',
  base_unit_6: '24px',
  base_unit_7: '32px',
  base_unit_8: '48px',
  base_unit_9: '64px',
  base_unit_10: '80px',


};

export default spacing;
